import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";

import classNames from "classnames";

const RenderLoading = () => {
  return (
    <div className={classNames("assessments-loading")}>
      <div className="card h-full">
        <div className="flex justify-between items-center mb-4">
          <Skeleton variant="rectangular" width="30%" height={40} />
          <Skeleton variant="rectangular" width="15%" height={40} />
        </div>

        <TableContainer component={Paper} className="shadow-lg rounded-lg">
          <Table>
            <TableHead className="bg-gray-200">
              <TableRow>
                <TableCell sx={{ width: "250px" }}>
                  <Skeleton width="90%" />
                </TableCell>
                <TableCell sx={{ width: "150px" }}>
                  <Skeleton width="90%" />
                </TableCell>
                <TableCell>
                  <Skeleton width="80%" />
                </TableCell>
                <TableCell>
                  <Skeleton width="80%" />
                </TableCell>
                <TableCell>
                  <Skeleton width="90%" />
                </TableCell>
                <TableCell>
                  <Skeleton width="80%" />
                </TableCell>
                <TableCell>
                  <Skeleton width="90%" />
                </TableCell>
                <TableCell>
                  <Skeleton width="80%" />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.from({ length: 11 }).map((_, index) => (
                <TableRow key={index} className="hover:bg-gray-100">
                  <TableCell>
                    <Skeleton width="90%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="85%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="75%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="70%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="85%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="70%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="85%" />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="rectangular" width="50%" height={30} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default RenderLoading;
